import { useRef } from 'react';
const useMultiSelectChipNavigation = ({ categories, onChipSelected, }) => {
    const doneButtonRef = useRef(null);
    const focusChip = (categoryKey, chipIndex) => {
        const chip = document.querySelector(`[data-category='${categoryKey}'][data-id='${chipIndex}']`);
        if (chip)
            chip.focus();
    };
    const handleNavigation = (key, shiftKey, currentIndex, currentCategoryIndex) => {
        let nextIndex = currentIndex;
        let nextCategoryIndex = currentCategoryIndex;
        const isForward = key === 'ArrowRight' || (key === 'Tab' && !shiftKey);
        const isBackward = key === 'ArrowLeft' || (key === 'Tab' && shiftKey);
        if (isForward) {
            if (currentIndex === categories[currentCategoryIndex].chips.length - 1) {
                nextIndex = 0;
                nextCategoryIndex = (currentCategoryIndex + 1) % categories.length;
            }
            else {
                nextIndex += 1;
            }
            focusChip(categories[nextCategoryIndex ?? currentCategoryIndex].key, nextIndex);
            if (nextIndex === 0 && nextCategoryIndex === 0) {
                doneButtonRef.current?.focus();
            }
        }
        if (isBackward) {
            if (currentIndex === 0) {
                nextCategoryIndex =
                    (currentCategoryIndex - 1 + categories.length) % categories.length;
                nextIndex = categories[nextCategoryIndex].chips.length - 1;
            }
            else {
                nextIndex -= 1;
            }
            focusChip(categories[nextCategoryIndex ?? currentCategoryIndex].key, nextIndex);
            if (currentIndex === 0 && currentCategoryIndex === 0) {
                doneButtonRef.current?.focus();
            }
        }
    };
    const handleKeyDown = (event, currentChip, category) => {
        const { key, shiftKey } = event;
        const currentCategoryIndex = categories.findIndex((cat) => cat.key === category.key);
        const currentIndex = category.chips.indexOf(currentChip);
        if (isNaN(currentIndex) || currentCategoryIndex === -1) {
            return;
        }
        if ((key === 'Enter' || key === ' ') && category && currentChip) {
            onChipSelected(category, currentChip);
        }
        event?.preventDefault();
        event?.stopPropagation();
        handleNavigation(key, shiftKey, currentIndex, currentCategoryIndex);
    };
    const handleButtonKeyDown = (event) => {
        const { key, shiftKey } = event;
        if (key === 'ArrowRight' || (key === 'Tab' && !shiftKey)) {
            focusChip(categories[0].key, 0);
        }
        else if (key === 'ArrowLeft' || (key === 'Tab' && shiftKey)) {
            const lastCategory = categories[categories.length - 1];
            focusChip(lastCategory.key, lastCategory.chips.length - 1);
        }
    };
    return {
        handleKeyDown,
        handleButtonKeyDown,
        doneButtonRef,
    };
};
export default useMultiSelectChipNavigation;
